import { render, staticRenderFns } from "./ConstructionProjectsView.vue?vue&type=template&id=1991bda0&scoped=true&"
import script from "./ConstructionProjectsView.vue?vue&type=script&lang=js&"
export * from "./ConstructionProjectsView.vue?vue&type=script&lang=js&"
import style0 from "./ConstructionProjectsView.vue?vue&type=style&index=0&id=1991bda0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1991bda0",
  null
  
)

/* custom blocks */
import block0 from "./ConstructionProjectsView.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports